import { useMemo } from "react";
import tvgConf from "@tvg/conf";
import { VALID_ENVS } from "./constraints";
import { readDevstack } from "./devstack";
import { BannerProps, Environments } from "./types";

export const useBannerInfo = (isEnvBannerEnabled: boolean): BannerProps =>
  useMemo(() => {
    const { environment, brand } = tvgConf();

    if (
      !isEnvBannerEnabled ||
      typeof window !== "object" ||
      !VALID_ENVS.includes(environment)
    )
      return {
        env: environment,
        hideBanner: true,
        isLocal: false,
        canChangeEnv: false,
        brand
      };

    const isLocal = window.location.hostname.includes("local");

    return {
      // @tvg/conf reports a real environment locally, because that is the
      // backend being talked to. Without the prefix the banner reads as a
      // deployed environment.
      env: (isLocal ? `local-${environment}` : environment) as Environments,
      hideBanner: false,
      isLocal,
      canChangeEnv: true,
      brand
    };
  }, [isEnvBannerEnabled]);

/** The devstack comes from the hostname, which is the only thing that says it. */
export const useDevStack = (isEnvBannerEnabled: boolean) =>
  useMemo(() => {
    if (!isEnvBannerEnabled || typeof window !== "object") return "";

    return readDevstack(window.location.hostname);
  }, [isEnvBannerEnabled]);
